const aiVarOne = [
  {
      "name": "ChatGPT",
      "url": "https://chat.openai.com",
      "icon": "images/chatgpt.jpg",
      "description": "对话式人工智能聊天机器人，功能丰富、智能化、易用性强，适用于对话交流、智能问答等场景。",
      isVpn: true
  },
  {
      "name": "DeepSeek",
      "url": "https://www.deepseek.com",
      "icon": "/images/deepseek.png",
      "description": "深度探索未知工具，适用于未知领域的探索和研究，帮助用户发现新知识和见解。"
  },
  {
      "name": "豆包",
      "url": "https://www.doubao.com",
      "icon": "https://lf-flow-web-cdn.doubao.com/obj/flow-doubao/samantha/logo-icon-white-bg.png",
      "description": "豆包是由字节跳动公司开发的人工智能。它经过大量数据的训练和优化，能够理解自然语言并生成相应的回答"
  },
  {
      "name": "文心一言",
      "url": "https://yiyan.baidu.com",
      "icon": '/images/wxyy.png',
      "description": "百度出品的人工智能语言模型，适用于智能问答、对话交流，提供自然语言交互和信息服务。"
  },
  {
      "name": "通义",
      "url": "https://tongyi.aliyun.com",
      "icon": "https://img.alicdn.com/imgextra/i4/O1CN01EfJVFQ1uZPd7W4W6i_!!6000000006051-2-tps-112-112.png",
      "description": "基于通义大模型的个人AI助手，ppt创作，阅读助手，实时记录"
  },
  {
      "name": "Midjourney",
      "url": "https://www.midjourney.com",
      "icon": "images/midjourney.png",
      "description": "创意工具，搭载在Discord上，适用于创意设计和艺术生成，帮助用户快速创建视觉内容。",

  },
  {
      "name": "Runway",
      "url": "https://runwayml.com",
      "icon": "images/runway.png",
      "description": "由人工智能驱动的创意工具，适用于视频编辑和创意制作，提供智能化的创作辅助。"
  },
  {
      "name": "通义灵码",
      "url": "https://tongyi.aliyun.com/lingma",
      "icon": "https://img.alicdn.com/imgextra/i4/O1CN01EfJVFQ1uZPd7W4W6i_!!6000000006051-2-tps-112-112.png",
      "description": "基于通义大模型的代码智能生成工具，适用于软件开发和编程，提高编码效率和质量。"
  },
  {
      "name": "秘塔AI搜索",
      "url": "https://www.mitata.cn",
      "icon": "https://metaso.cn/favicon.ico",
      "description": "无广告的搜索引擎，直达结果，适用于信息检索和搜索，提供高效准确的搜索服务。"
  },
  {
      "name": "Perplexity",
      "url": "https://www.perplexity.ai",
      "icon": "images/Perplexity.png",
      "description": "对话式搜索引擎，适用于智能问答和信息检索，通过自然语言交互提供精准信息。",
      isVpn: "国外AI,需要外网工具访问"
  },
  {
      "name": "Hugging Face",
      "url": "https://huggingface.co",
      "icon": "images/huggingface.png",
      "description": "提供开源数据集和预训练模型，适用于机器学习和人工智能研究，支持开发者快速构建和训练模型。",
      isVpn: "国外AI,需要外网工具访问"
  },
  {
      "name": "Character AI",
      "url": "https://character.ai",
      "icon": "images/character.png",
      "description": "神经语言模型聊天机器人，适用于对话交流和角色扮演，提供个性化的交互体验。",
      isVpn: "国外AI,需要外网工具访问"
  },
  {
      "name": "Grammarly",
      "url": "https://www.grammarly.com",
      "icon": "https://static-web.grammarly.com/cms/master/public/favicon.ico",
      "description": "在线语法纠正和校对工具，适用于写作和编辑，帮助用户提升文本质量和专业性。"
  },
  {
      "name": "Cursor",
      "url": "https://www.cursor.so",
      "icon": "images/cursor.jpg",
      "description": "使用GPT-4编写代码的工具，适用于软件开发和编程，提高编码效率和准确性。",
      isVpn: "国外AI,需要外网工具访问"
  },
  {
      "name": "通义千问",
      "url": "https://tongyi.aliyun.com",
      "icon": "https://img.alicdn.com/imgextra/i4/O1CN01EfJVFQ1uZPd7W4W6i_!!6000000006051-2-tps-112-112.png",
      "description": "阿里开发的大语言模型，适用于智能问答、对话交流，提供自然语言交互和信息服务。"
  },
  {
      "name": "讯飞星火",
      "url": "https://xinghuo.xfyun.cn",
      "icon": "https://xinghuo.xfyun.cn/favicon.ico",
      "description": "科大讯飞推出的新一代认知智能大模型，适用于智能客服、语音识别，提供智能化的语音交互服务。"
  },
  {
      "name": "Adobe Firefly",
      "url": "https://www.adobe.com/products/firefly.html",
      "icon": "images/adobefirefly.png",
      "description": "无限创作工具，适用于创意设计和艺术生成，帮助用户快速创建视觉内容。"
  },
  {
      "name": "Galileo AI",
      "url": "https://www.usegalileo.ai/explore",
      "icon": "https://www.usegalileo.ai/assets/favicon/favicon-196x196.png",
      "description": "AI生成UI平台，适用于用户界面设计和开发，提供智能化的UI设计和生成服务。"
  },
  {
      "name": "Fitten Code",
      "url": "https://code.fittentech.com/",
      "icon": "https://code.fittentech.com/favicon.ico",
      "description": "代码生成和调试工具，适用于软件开发和编程，提高编码效率和准确性。"
  },
  {
      "name": "RemoveBG",
      "url": "https://www.remove.bg/zh",
      "icon": "https://www.remove.bg/favicon.ico?v=fc0bfce6e1310f1539afec9729716721",
      "description": "图片背景去除工具，适用于图片编辑和处理，帮助用户快速去除图片背景。"
  },
  {
      "name": "Clipdrop",
      "url": "https://clipdrop.co",
      "icon": "images/Clipdrop.jpg",
      "description": "AI图像处理工具，适用于图像编辑和增强，提供智能化的图像处理服务。",
      isVpn: '国外AI,需要外网工具访问,请确保已经打开外网访问工具'
  },
  {
      "name": "Quillbot",
      "url": "https://quillbot.com",
      "icon": "images/quillbot.jpg",
      "description": "人工智能驱动的转述工具，适用于写作辅助和文本改写，帮助用户提升文本质量和原创性。",
      isVpn: '国外AI,需要外网工具访问,请确保已经打开外网访问工具'
  },
  {
      "name": "Writesonic",
      "url": "https://writesonic.com",
      "icon": "images/writersonic.jpg",
      "description": "AI作家，适用于内容创作和文案撰写，提高创作效率和质量。",
      isVpn: '国外AI,需要外网工具访问,请确保已经打开外网访问工具'
  },
  {
      "name": "Notion AI",
      "url": "https://www.notion.so/ai",
      "icon": "images/notion.png",
      "description": "工作辅助工具，提升办公效率和写作质量，适用于办公和生产力提升。"
  },
  {
      "name": "getimg.ai",
      "url": "https://getimg.ai",
      "icon": "images/getimg.png",
      "description": "图像生成工具，专注于头像生成，帮助用户快速创建个性化头像。",
      isVpn: true
  },
  {
      "name": "Phygital+",
      "url": "https://phygital.plus",
      "icon": "https://static.tildacdn.com/tild3361-6632-4236-b634-306134333837/PhygitalLogo.svg",
      "description": "AI工具整合平台，适用于综合AI工具使用，提供一站式的AI服务。"
  },
  {
      "name": "Autodraw",
      "url": "https://www.autodraw.com",
      "icon": "images/autodraw.jpg",
      "description": "人工智能画画平台，适用于绘画和创意设计，帮助用户快速创建视觉内容。"
  },
  {
      "name": "GitHub Copilot",
      "url": "https://github.com/features/copilot",
      "icon": "https://github.githubassets.com/favicons/favicon.png",
      "description": "代码配对工具，提升编码效率，适用于软件开发和编程。"
  },
  {
      "name": "Stable Diffusion",
      "url": "https://stablediffusionweb.com",
      "icon": "images/stablediffusionweb.png",
      "description": "AI绘画工具，输入关键字生成图片，适用于图像生成和艺术创作。"
  },
  {
      "name": "Civitai",
      "url": "https://civitai.com",
      "icon": "images/civitai-icon-filled-36.png",
      "description": "训练好的模型分享网站，适用于机器学习和模型分享，支持开发者快速获取和部署模型。"
  },
  {
      "name": "Genmo",
      "url": "https://www.genmo.ai",
      "icon": "images/genmo.jpg",
      "description": "图片生成视频AI，适用于视频生成和编辑，帮助用户快速创建视频内容。"
  },
  {
      "name": "Kimi",
      "url": "https://kimi.moonshot.cn",
      "icon": "https://kimi.moonshot.cn/favicon.ico",
      "description": "国内最接近chatGPT的AI，适用于智能问答、对话交流，提供自然语言交互和信息服务。"
  },
  // {
  //     "name": "Copilot X",
  //     "url": "https://github.com/features/preview/copilot-x",
  //     "icon": "https://github.githubassets.com/favicons/favicon.png",
  //     "description": "GitHub和OpenAI合作开发的AI助手，适用于软件开发和编程辅助，提高编码效率和准确性。"
  // },
  {
      "name": "Suno",
      "url": "https://suno.ch",
      "icon": "images/suno.jpg",
      "description": "专业高质量的AI歌曲和音频生成工具，适用于音乐创作和音频生成。"
  },
  {
      "name": "Liner",
      "url": "https://www.liner.com",
      "icon": "images/liner.png",
      "description": "基于ChatGPT的对话式人工智能搜索助手，适用于信息检索和智能问答。"
  },
  {
      "name": "JanitorAI",
      "url": "https://janitorai.com",
      "icon": "images/janitorai.jpg",
      "description": "个性化、无限制的AI角色的聊天机器人，适用于对话交流和娱乐。"
  },
  {
      "name": "SpicyChat",
      "url": "https://spicy.chat",
      "icon": "images/spicy.jpg",
      "description": "AI角色的聊天机器人，适用于对话交流和娱乐。"
  },
  {
      "name": "Gamma AI",
      "url": "https://gamma.app",
      "icon": "images/gamma.jpg",
      "description": "以人工智能为动力的创意工具，适用于创意设计和艺术生成。"
  },
  {
      "name": "Coze",
      "url": "https://www.coze.com",
      "icon": "images/coze.png",
      "description": "AI聊天机器人构建平台，适用于聊天机器人开发和部署。"
  },
  {
      "name": "Gemini",
      "url": "https://ai.google.com",
      "icon": "images/maxai.jpg",
      "description": "Google推出的AI聊天对话机器人，适用于对话交流和智能问答。"
  },
  {
      "name": "豆包",
      "url": "https://doubao.com",
      "icon": "images/doubao.png",
      "description": "抖音旗下的AI助手，适用于智能问答和信息检索。"
  },
  {
      "name": "腾讯元宝",
      "url": "https://yuanbao.tencent.com/chat/naQivTmsDa",
      "icon": "images/yuanbao.webp",
      "description": "腾讯出品的大语言模型，适用于智能问答、对话交流。"
  },
  {
      "name": "Bing Copilop",
      "url": "https://www.bing.com/copilot",
      "icon": "images/Pic-Copilot.png",
      "description": "一键直达结果的搜索工具，适用于信息检索和搜索。",

  },
  {
      "name": "Grok AI",
      "url": "https://x.ai/grok",
      "icon": "images/grok.png",
      "description": "双千亿级大语言模型，适用于智能问答、对话交流等场景。",
      isVpn: true
  }
]


export default aiVarOne
